export const header = (title, companyInfo) =>
({
    style: "header",
    layout: 'noBorders',
    table: {
        widths:["auto", "*", 'auto', 'auto'],
        heights: 100,
        body: [[
          { text: title, style: 'headerTitle' },
          { text: "" },
          {
              style: "contactInfo",
              stack: [
                { text: companyInfo.companyPhone, style: "alignRight" },
                { text: companyInfo.companyEmail, style: "alignRight" },
              ]
          },
          {
            style: "address",
            stack: [
              { text: companyInfo.address.street, style: "alignRight" },
              { text: `${companyInfo.address.city}, ${companyInfo.address.province}, ${companyInfo.address.country}`, style: "alignRight" },
              { text: companyInfo.address.postalCode, style: "alignRight" },
            ]
          },
        ]]
    }
});



// WEBPACK FOOTER //
// ./src/store/generators/PDF/core/header.js